import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    body: (count: number) =>
      translate({
        id: 'settings.users.view.deleteUserConfirmationModal.header.body',
        values: { count },
      }),
  }))

  return api
}
